var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [_vm._v(_vm._s(_vm.showStatus))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "about-to-start" },
      [
        _c("h1", { staticClass: "status" }, [_vm._v(_vm._s(_vm.aboutToStart))]),
        _vm._v(" "),
        _vm._l(_vm.imminentSessions, function(session) {
          return _c("div", { staticClass: "block" }, [
            _c("h2", { staticStyle: { color: "#297ec0" } }, [
              _c("a", { attrs: { href: _vm.link(session.session_id) } }, [
                _vm._v(_vm._s(session.session.title))
              ]),
              _vm._v(" "),
              _c("small", [_vm._v("#" + _vm._s(session.session_id))])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.getTime(
                    session.session.starts_at,
                    session.session.ends_at
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: session.session.is_cancelled,
                      expression: "session.session.is_cancelled"
                    }
                  ],
                  staticClass: "tag is-danger"
                },
                [_vm._v("CANCELLED")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !session.session.is_cancelled,
                      expression: "!session.session.is_cancelled"
                    }
                  ],
                  staticClass: "tag",
                  style: _vm.sessionTagColor(session.session.urlType),
                  attrs: { href: _vm.goToUrl(session), target: "_blank" }
                },
                [
                  _vm._v(
                    "\n              Go to " +
                      _vm._s(session.session.locationName) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: session.session.formatName,
                      expression: "session.session.formatName"
                    }
                  ],
                  staticClass: "tag"
                },
                [_vm._v("\n            " + _vm._s(session.session.formatName))]
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: session.session.typeName,
                      expression: "session.session.typeName"
                    }
                  ],
                  staticClass: "tag",
                  style: _vm.tagColor(session)
                },
                [_vm._v("\n            " + _vm._s(session.session.typeName))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: session.session.subtypeName,
                      expression: "session.session.subtypeName"
                    }
                  ],
                  staticClass: "tag is-default"
                },
                [_vm._v("\n            " + _vm._s(session.session.subtypeName))]
              )
            ]),
            _vm._v(" "),
            session.session.is_promotional
              ? _c("p", [
                  _c("span", { staticClass: "is-danger tag" }, [
                    _vm._v("Promotional")
                  ]),
                  _vm._v(" "),
                  session.session.organization
                    ? _c("span", [
                        _vm._v("\n          Visit "),
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href: _vm.organizationUrl(session.session)
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(session.session.organization.name) +
                                "\n          "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "presenters" },
              _vm._l(session.session.participants, function(p) {
                return _c("span", { staticClass: "pr" }, [
                  _c("span", [_vm._v(_vm._s(_vm.showName(p)))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "delimiter" }, [_vm._v(" / ")])
                ])
              }),
              0
            )
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "in-progress" },
      [
        _c("h1", { staticClass: "status" }, [_vm._v(_vm._s(_vm.inProgress))]),
        _vm._v(" "),
        _vm._l(_vm.progressSessions, function(session) {
          return _c("div", { staticClass: "block" }, [
            _c("h2", { staticStyle: { color: "#297ec0" } }, [
              _c("a", { attrs: { href: _vm.link(session.session_id) } }, [
                _vm._v(_vm._s(session.session.title))
              ]),
              _vm._v(" "),
              _c("small", [_vm._v("#" + _vm._s(session.session_id))])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("small", [
                _vm._v(
                  _vm._s(
                    _vm.getTime(
                      session.session.starts_at,
                      session.session.ends_at
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: session.session.is_cancelled,
                      expression: "session.session.is_cancelled"
                    }
                  ],
                  staticClass: "tag is-danger"
                },
                [_vm._v("CANCELLED")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !session.session.is_cancelled,
                      expression: "!session.session.is_cancelled"
                    }
                  ],
                  staticClass: "tag",
                  style: _vm.sessionTagColor(session.session.urlType),
                  attrs: { href: _vm.goToUrl(session), target: "_blank" }
                },
                [
                  _vm._v(
                    "\n            Go to " +
                      _vm._s(session.session.locationName) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: session.session.formatName,
                      expression: "session.session.formatName"
                    }
                  ],
                  staticClass: "tag"
                },
                [_vm._v("\n            " + _vm._s(session.session.formatName))]
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: session.session.typeName,
                      expression: "session.session.typeName"
                    }
                  ],
                  staticClass: "tag",
                  style: _vm.tagColor(session)
                },
                [_vm._v("\n            " + _vm._s(session.session.typeName))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: session.session.subtypeName,
                      expression: "session.session.subtypeName"
                    }
                  ],
                  staticClass: "tag is-default"
                },
                [_vm._v("\n            " + _vm._s(session.session.subtypeName))]
              )
            ]),
            _vm._v(" "),
            session.session.is_promotional
              ? _c("p", [
                  _c("span", { staticClass: "is-danger tag" }, [
                    _vm._v("Promotional")
                  ]),
                  _vm._v(" "),
                  session.session.organization
                    ? _c("span", [
                        _vm._v("\n          Visit "),
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href: _vm.organizationUrl(session.session)
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(session.session.organization.name) +
                                "\n          "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "presenters" },
              _vm._l(session.session.participants, function(p) {
                return _c("span", { staticClass: "pr" }, [
                  _c("span", [_vm._v(_vm._s(_vm.showName(p)))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "delimiter" }, [_vm._v(" / ")])
                ])
              }),
              0
            )
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }